import { ContactFields, isAuthError, useAuth0 } from '@brighte/passwordless-authenticator';
import { ApplicationFormSubStatus } from '@brighte/validation';
import { Loader } from '@components/Loader/Loader';
import PageTitle from '@components/PageTitle/PageTitle';
import { ApplicantStatus, ApplicantType, QuoteStatus as Status, useApplicationDetailsQuery } from '@graphql/index';
import OfferAcceptance from '@pages/OfferAcceptance/OfferAcceptance';
import QuoteStatus from '@pages/QuoteStatusPage/QuoteStatusPage';
import { useApplicationData, useSetApplicationData } from '@provider';
import { getApplicantTypeAndTrackingIdFromUrl, isJointApplicant } from '@utils';

function SubmittedApplication() {
  const prePopContactDetails = useApplicationData('ContactDetails');

  const setApplicationData = useSetApplicationData();

  const { verificationCompleted } = useAuth0();

  const { trackingId, applicantType } = getApplicantTypeAndTrackingIdFromUrl();

  const { data: application, isLoading } = useApplicationDetailsQuery(
    { applicationId: trackingId, joint: applicantType === ApplicantType.Joint },
    {
      enabled: verificationCompleted,
      select: data => data.application,
      retry: 0,
      onSuccess: data => data && setApplicationData({ application: data }),
      useErrorBoundary: (error: unknown) => isAuthError(error),
    },
  );

  const applicantStatus = isJointApplicant()
    ? application?.jointApplicant?.status
    : application?.primaryApplicant?.status;

  const handleLoginError = (error: unknown) => {
    throw error;
  };

  if (isLoading && verificationCompleted) {
    return <Loader />;
  }

  if (!application) {
    return (
      <>
        <PageTitle />
        <ContactFields
          verificationDetails={{
            email: prePopContactDetails?.email,
            mobile: prePopContactDetails?.mobile,
            verificationType: prePopContactDetails?.verificationType,
            maskedEmail: prePopContactDetails?.maskedEmail,
            maskedMobile: prePopContactDetails?.maskedMobile,
          }}
          onError={handleLoginError}
        />
      </>
    );
  }

  return (
    <>
      {application.subStatus === ApplicationFormSubStatus.PendingAcceptance &&
      applicantStatus === ApplicantStatus.Submitted ? (
        <OfferAcceptance />
      ) : (
        <QuoteStatus status={Status.COMPLETED} />
      )}
    </>
  );
}

export default SubmittedApplication;
